import { __decorate, __param } from 'tslib';
import { DOCUMENT, CommonModule } from '@angular/common';
import { Inject, ElementRef, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { tuiAssert, TUI_DIALOGS, TUI_IS_MOBILE, TuiDragModule, TuiDropdownHostModule, TuiDialogHostModule, TuiAlertHostModule } from '@taiga-ui/cdk';
import { VERSION } from '@taiga-ui/core/constants';
import { TUI_IS_MOBILE_RES_PROVIDER } from '@taiga-ui/core/providers';
import { TUI_ANIMATIONS_DURATION, TUI_ASSERT_ENABLED, TUI_IS_MOBILE_RES, TUI_THEME } from '@taiga-ui/core/tokens';
import { merge, of, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TuiHintsHostModule } from '@taiga-ui/core/components/hints-host';
import { TuiScrollControlsModule } from '@taiga-ui/core/components/scroll-controls';
import { TuiSvgDefsHostModule } from '@taiga-ui/core/internal/svg-defs-host';
import { EventPluginsModule } from '@tinkoff/ng-event-plugins';

// @dynamic
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/core/internal/svg-defs-host';
import * as ɵngcc3 from '@taiga-ui/cdk';
import * as ɵngcc4 from '@taiga-ui/core/components/hints-host';
import * as ɵngcc5 from '@taiga-ui/core/components/scroll-controls';
import * as ɵngcc6 from 'rxjs';

function TuiRootComponent_tui_scroll_controls_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-scroll-controls", 2);
} }
const _c0 = ["*", [["tuiOverContent"]], [["tuiOverDialogs"]], [["tuiOverAlerts"]], [["tuiOverNotifications"]], [["tuiOverPortals"]], [["tuiOverHints"]]];
const _c1 = ["*", "tuiOverContent", "tuiOverDialogs", "tuiOverAlerts", "tuiOverNotifications", "tuiOverPortals", "tuiOverHints"];
let TuiRootComponent = class TuiRootComponent {
    constructor(duration, elementRef, dialogs, isMobile, enabled, isMobileRes$, { body }, theme) {
        this.duration = duration;
        this.elementRef = elementRef;
        this.dialogs = dialogs;
        this.isMobile = isMobile;
        this.isMobileRes$ = isMobileRes$;
        this.scrollbars$ = this.dialogs.length && !this.isMobile
            ? merge(...this.dialogs).pipe(map(({ length }) => !length))
            : of(!this.isMobile);
        tuiAssert.enabled = enabled;
        body.setAttribute('data-tui-theme', theme.toLowerCase());
    }
};
TuiRootComponent.ɵfac = function TuiRootComponent_Factory(t) { return new (t || TuiRootComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_ANIMATIONS_DURATION), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TUI_DIALOGS), ɵngcc0.ɵɵdirectiveInject(TUI_IS_MOBILE), ɵngcc0.ɵɵdirectiveInject(TUI_ASSERT_ENABLED), ɵngcc0.ɵɵdirectiveInject(TUI_IS_MOBILE_RES), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(TUI_THEME)); };
TuiRootComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiRootComponent, selectors: [["tui-root"]], hostAttrs: ["data-tui-version", "2.42.0"], hostVars: 2, hostBindings: function TuiRootComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("$.class._mobile", function TuiRootComponent___class__mobile_HostBindingHandler() { return ctx.isMobileRes$; });
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("--tui-duration", ctx.duration + "ms");
    } }, features: [ɵngcc0.ɵɵProvidersFeature([TUI_IS_MOBILE_RES_PROVIDER])], ngContentSelectors: _c1, decls: 15, vars: 3, consts: [["class", "scrollbar", 4, "ngIf"], [1, "content"], [1, "scrollbar"]], template: function TuiRootComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵtemplate(0, TuiRootComponent_tui_scroll_controls_0_Template, 1, 0, "tui-scroll-controls", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵelement(2, "tui-svg-defs-host");
        ɵngcc0.ɵɵelementStart(3, "tui-dropdown-host");
        ɵngcc0.ɵɵelementStart(4, "div", 1);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelement(7, "tui-dialog-host");
        ɵngcc0.ɵɵprojection(8, 2);
        ɵngcc0.ɵɵelement(9, "tui-alert-host");
        ɵngcc0.ɵɵprojection(10, 3);
        ɵngcc0.ɵɵprojection(11, 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(12, 5);
        ɵngcc0.ɵɵelement(13, "tui-hints-host");
        ɵngcc0.ɵɵprojection(14, 6);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.scrollbars$));
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.TuiSvgDefsHostComponent, ɵngcc3.TuiDropdownHostComponent, ɵngcc3.TuiDialogHostComponent, ɵngcc3.TuiAlertHostComponent, ɵngcc4.TuiHintsHostComponent, ɵngcc5.TuiScrollControlsComponent], pipes: [ɵngcc1.AsyncPipe], styles: ["[_nghost-%COMP%]{position:relative;display:block;flex:1}.scrollbar[_ngcontent-%COMP%]{position:fixed;top:0;left:0;bottom:0;right:0;margin:0}.content[_ngcontent-%COMP%]{position:relative;z-index:0;height:100%}"], changeDetection: 0 });
TuiRootComponent.ctorParameters = () => [
    { type: Number, decorators: [{ type: Inject, args: [TUI_ANIMATIONS_DURATION,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_DIALOGS,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_MOBILE,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_ASSERT_ENABLED,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_IS_MOBILE_RES,] }] },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: String, decorators: [{ type: Inject, args: [TUI_THEME,] }] }
];
TuiRootComponent = __decorate([ __param(0, Inject(TUI_ANIMATIONS_DURATION)),
    __param(1, Inject(ElementRef)),
    __param(2, Inject(TUI_DIALOGS)),
    __param(3, Inject(TUI_IS_MOBILE)),
    __param(4, Inject(TUI_ASSERT_ENABLED)),
    __param(5, Inject(TUI_IS_MOBILE_RES)),
    __param(6, Inject(DOCUMENT)),
    __param(7, Inject(TUI_THEME))
], TuiRootComponent);

let TuiRootModule = class TuiRootModule {
};
TuiRootModule.ɵfac = function TuiRootModule_Factory(t) { return new (t || TuiRootModule)(); };
TuiRootModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiRootModule });
TuiRootModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            EventPluginsModule,
            TuiDragModule,
            TuiDropdownHostModule,
            TuiSvgDefsHostModule,
            TuiHintsHostModule,
            TuiDialogHostModule,
            TuiAlertHostModule,
            TuiScrollControlsModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiRootComponent, [{
        type: Component,
        args: [{
                selector: 'tui-root',
                template: "<tui-scroll-controls\n    *ngIf=\"scrollbars$ | async\"\n    class=\"scrollbar\"\n></tui-scroll-controls>\n<tui-svg-defs-host></tui-svg-defs-host>\n<tui-dropdown-host>\n    <div class=\"content\">\n        <ng-content></ng-content>\n    </div>\n    <ng-content select=\"tuiOverContent\"></ng-content>\n    <tui-dialog-host></tui-dialog-host>\n    <ng-content select=\"tuiOverDialogs\"></ng-content>\n    <tui-alert-host></tui-alert-host>\n    <ng-content select=\"tuiOverAlerts\"></ng-content>\n    <!-- TODO: Remove-->\n    <ng-content select=\"tuiOverNotifications\"></ng-content>\n</tui-dropdown-host>\n<ng-content select=\"tuiOverPortals\"></ng-content>\n<tui-hints-host></tui-hints-host>\n<ng-content select=\"tuiOverHints\"></ng-content>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [TUI_IS_MOBILE_RES_PROVIDER],
                host: {
                    'data-tui-version': VERSION,
                    '[style.--tui-duration]': 'duration + "ms"',
                    '($.class._mobile)': 'isMobileRes$'
                },
                styles: [":host{position:relative;display:block;flex:1}.scrollbar{position:fixed;top:0;left:0;bottom:0;right:0;margin:0}.content{position:relative;z-index:0;height:100%}"]
            }]
    }], function () { return [{ type: Number, decorators: [{
                type: Inject,
                args: [TUI_ANIMATIONS_DURATION]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_DIALOGS]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_MOBILE]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_ASSERT_ENABLED]
            }] }, { type: ɵngcc6.Observable, decorators: [{
                type: Inject,
                args: [TUI_IS_MOBILE_RES]
            }] }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [TUI_THEME]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiRootModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    EventPluginsModule,
                    TuiDragModule,
                    TuiDropdownHostModule,
                    TuiSvgDefsHostModule,
                    TuiHintsHostModule,
                    TuiDialogHostModule,
                    TuiAlertHostModule,
                    TuiScrollControlsModule,
                ],
                declarations: [TuiRootComponent],
                exports: [TuiRootComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiRootModule, { declarations: function () { return [TuiRootComponent]; }, imports: function () { return [CommonModule,
        EventPluginsModule,
        TuiDragModule,
        TuiDropdownHostModule,
        TuiSvgDefsHostModule,
        TuiHintsHostModule,
        TuiDialogHostModule,
        TuiAlertHostModule,
        TuiScrollControlsModule]; }, exports: function () { return [TuiRootComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiRootComponent, TuiRootModule };

